<ng-container>
  <nz-row class="message-wrapper">
    <form [formGroup]="form" (ngSubmit)="sendMessage()" class="message-form">
      <textarea
        #textarea
        class="textarea-input"
        placeholder="Send a message"
        formControlName="message"
        rows="1"
        (input)="autoResize()"
      ></textarea>
    </form>

    @if (!isLoading()) {
      <button title="Send" (click)="sendMessage()" [disabled]="form.invalid">
        <i nz-icon nzType="send" nzTheme="outline"></i>
      </button>
    } @else {
      <button title="Abort" type="button" (click)="abortProcessing()">
        <i nz-icon nzType="stop" nzTheme="outline"></i>
      </button>
    }
  </nz-row>
</ng-container>
